import { useSelector } from "react-redux";

import { MetaFieldType } from "src/app/methods/getMetaFieldTypeOptions";
import { RootState } from "src/redux/reducers";
import { AiFileAnalysis } from "src/types";

const useGetProjectBriefData = () => {
  const { projectBasicData } = useSelector(
    (state: RootState) => state.projectReducer,
  );

  const briefMetaFieldUuid = projectBasicData?.briefMetaFieldUuid || "";

  const value = projectBasicData?.metadata.find(
    (field) =>
      field.type === MetaFieldType.AiFileAnalysis &&
      field.uuid === briefMetaFieldUuid,
  )?.value as AiFileAnalysis | undefined;

  const assets = value?.assets?.[0];
  const briefName = assets?.fileName ?? "";
  const briefContent = value?.content ?? "";
  const briefFileData = assets?.wsAssetQuery ?? null;
  const briefCampaignSuggestions = value?.campaign_suggestions ?? null;

  return {
    briefName,
    briefContent,
    briefFileData,
    briefMetaFieldUuid,
    briefCampaignSuggestions,
  };
};

export default useGetProjectBriefData;
